import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel, Select } from '@mui/material';
import { SelectPlaceholder } from '../selectPlaceholder';
export const EmptySelect = t0 => {
  const $ = _c(10);
  const {
    title,
    size: t1,
    value
  } = t0;
  const size = t1 === undefined ? "small" : t1;
  let t2;
  if ($[0] !== title) {
    t2 = title && <FormLabel>{title}</FormLabel>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== value) {
    t3 = () => <SelectPlaceholder title={value} />;
    $[2] = value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== size || $[5] !== t3) {
    t4 = <Select size={size} displayEmpty={true} renderValue={t3} disabled={true} value="" />;
    $[4] = size;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <FormControl size="small" className="flex-1">{t2}{t4}</FormControl>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};